<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
export default {
  name: 'App'
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
area {
  cursor: pointer;
  display:block;
}
/* Canvas */
canvas {
  /* pointer-events: none; */
  position: absolute;
}
html, .back {
  height: 100vh;
  background-color: #000;
}
.footer {
  position: absolute;
  width: 10%;
  bottom: 0;
  right: 0;
  padding: 15px;
  margin-bottom: 0!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue